import type { Partner } from "@/models";

export type MedBmiThresholds = {
  minBmi: number;
  minBmiWithComorbidity: number;
};

export const getMedBmiThresholds = (
  partnerInfo?: Partner | null,
): MedBmiThresholds => ({
  minBmi: partnerInfo?.configs?.MED_MIN_BMI ?? 30,
  minBmiWithComorbidity:
    partnerInfo?.configs?.MED_MIN_BMI_WITH_COMORBIDITY ?? 27,
});
